export const fillConfig: ApexFill = {
  type: 'gradient',
  colors: ['var(--chart-gradient-color)'],
  gradient: {
    type: 'vertical',
    opacityFrom: 0.6,
    opacityTo: 0
  }
}
